import React, { useEffect, useState } from "react";
import useFetch from "../hooks/useFetch";
import { toast } from "react-toastify";
import { Division } from "../types";
import OneLineCardSkeleton from "../components/SkeletonCards/OneLineCardSkeleton";
import DivisionCard from "../components/DivisionCard";
import { FileDownloadOutlined } from '@mui/icons-material';

interface DivisionsListingCardProps {
  type: string;
  divisions: any;
  settings_color_code: any;
  setParamAndFetch: (data: string) => void;
  dropdownState: boolean;
  setDropdownState: (data: boolean) => void;
  dropdownHeading: string;
  isLoading: boolean;
  excel_status: boolean;
  excel_file: string;
  excel_title: string;
}

const DivisionsListingCard: React.FC<DivisionsListingCardProps> = ({
  type,
  divisions,
  settings_color_code,
  setParamAndFetch,
  dropdownState,
  setDropdownState,
  dropdownHeading,
  isLoading,
  excel_status,
  excel_file,
  excel_title
}) => {

    const { fetchData: fetchFileDownload, data: fileDownloadResp, hasFetched: fileDownloadhasFetched } = useFetch({
      url: `${import.meta.env.VITE_API_URL}/divisions_performance_groups/downloadfile`,
      method: "POST",
    });
    const [excelDownload, setExcelDownload] = useState<string>('');
    useEffect(() => {
      if(fileDownloadhasFetched && excelDownload == "start"){
        if(fileDownloadResp?.result){
          const buffer = Buffer.from(fileDownloadResp?.result);
          const blob = new Blob([buffer]);
          if (blob instanceof Blob){
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            console.log("excel_title: ", excel_title);
            let title = excel_title.toLowerCase().trim().replace(/\s+/g, '_').replace(/[^a-z0-9_-]/g, '');
            title = `${title}.xlsx`;
            link.setAttribute("download", title);
            document.body.appendChild(link);
            link.click();
            //toast.info('File download successfully.');
          }else{
            toast.warn('Error while download file.');
          }
        }else{
          console.log("CSV Download: error on server side.");
          toast.warn('File not found.');
        } 
        setExcelDownload('');
      }
    }, [fileDownloadhasFetched]);
    
  return (
    <div className="w-layout-blockcontainer container-main-content w-container" style={{ paddingTop: "20px" }} >
      <div data-hover="false" data-delay="0" className="w-dropdown" style={{ marginBottom: 15, }}  onClick={() => { 
        (type !== 'My Team') ? (dropdownState ? setDropdownState(false) : setDropdownState(true)) : ''
          }}>
        <div className={ "view-all-drop-down "+(type !== 'My Team') ? 'w-dropdown-toggle' : '' }>
        {(type !== 'My Team') ? (<div className="w-icon-dropdown-toggle"></div>) : ('')}
          <div className="text-block">{dropdownHeading} ({divisions?.length})</div>
        </div>
        {
          (type !== 'My Team') ? (
            <nav className="dropdown-list w-dropdown-list" style={{ display: `${dropdownState?'block':'none'}`, }}>
              <a href="#" className="w-dropdown-link" onClick={() => setParamAndFetch('') }> View All </a>
              <a href="#" className="w-dropdown-link" onClick={() => setParamAndFetch('active') }> Active </a>
              <a href="#" className="w-dropdown-link" onClick={() => setParamAndFetch('approved') }> Approved </a>
              <a href="#" className="w-dropdown-link" onClick={() => setParamAndFetch('ready_to_announce') }> Ready To Announce </a>
              <a href="#" className="w-dropdown-link" onClick={() => setParamAndFetch('published') }> Published/Past </a>
              { /*(currentRole == 3 || currentRole == 6) ? (
              <a href="#" className="w-dropdown-link" onClick={() => setParamAndFetch('myteam') }> My Team </a>
              ) : ('')*/
              }
            </nav>
          ) : (null)
        }
        
      </div>
      {excel_status ? (
       <span style={{ cursor: 'pointer', display: 'block', float: 'right', padding:'20px'}} onClick={ 
                  async () =>  {
                    setExcelDownload('start');
                    await fetchFileDownload({filename:excel_file, type:'score report excel'});
                    } 
                  }
        >
        Download Report <FileDownloadOutlined style={{ verticalAlign: 'bottom' }}>  </FileDownloadOutlined>
      </span>
                ) : (null)}

      <div className="w-layout-layout quick-stack wf-layout-layout" >
        {isLoading ? (
          <OneLineCardSkeleton
            cardsCount={2}
            baseColor="#d3ddf3"
            highlightColor="#fff"
          />
        ) : (
          divisions && divisions.length > 0 ? (                 
            divisions?.map((division: Division, index:any) => {
                return (
                  <DivisionCard
                  key={index}
                  division={division}
                  settings_color_code={settings_color_code}
                  />
                );
              })                  
          ) : (
            <div className="w-layout-cell cursor-pointer scale--sm">
              <div>no record found</div>
            </div>
          )
          
        )}
      </div>
    </div>
  );
};

export default DivisionsListingCard;
